// Drawing completion for the shape kinds.
//  - area / object: click vertices, finish with double-click / Enter
//  - tensator: dedicated toolbar tool; each click drops a post, the belt is
//    drawn automatically between consecutive posts; "Fertig" / Enter commits the
//    current chain, a lone post (1 click) commits without a belt.
import { addShape } from "./state";
import { KIND_MIN_POINTS } from "./catalog";
import { session, setMode, select, clearDraft } from "./session";
import { toast } from "./ui/toast";
import type { Point } from "./types";

function dedupe(raw: readonly Point[]): Point[] {
  const pts: Point[] = [];
  for (const p of raw) {
    const prev = pts[pts.length - 1];
    if (prev && Math.hypot(p.x - prev.x, p.y - prev.y) < 6) continue;
    pts.push(p);
  }
  return pts;
}

export function finishShapeDraft(): void {
  const s = session();
  if (s.mode === "tensator") {
    commitTensatorChain();
    return;
  }

  const pts = dedupe(s.shapeDraft);
  const min = KIND_MIN_POINTS[s.shapeKind];
  if (pts.length < min) {
    toast(`Mindestens ${min} Punkte nötig, um eine Fläche abzuschließen.`);
    return;
  }

  const kind = s.shapeKind;
  const cat = s.shapeCat;
  setMode("select");
  const shape = addShape(kind, cat, pts, true);
  select({ type: "shape", id: shape.id });
}

/**
 * Commit the current tensator chain as one shape and start a fresh chain.
 * Stays in tensator mode so the next click begins the next post/chain.
 * A single post (1 point) is committed without a belt. `closed` is set when
 * the chain was ended by clicking back onto its own first post (loop, like
 * closing a Fläche) rather than via "Fertig"/Enter/double-click.
 */
export function commitTensatorChain(closed = false): void {
  const pts = dedupe(session().shapeDraft);
  clearDraft();
  if (pts.length < 1) return;
  addShape("line", "", pts, closed);
}
